import React, { createContext } from 'react'
import { useAuth0 } from '@auth0/auth0-react'
import axios, { AxiosInstance } from 'axios'

type VendorsFetchContextReturnType = {
  vendorsAxios: AxiosInstance
}

const VendorsFetchContext = createContext<VendorsFetchContextReturnType>({} as VendorsFetchContextReturnType)
const { Provider } = VendorsFetchContext

const VendorsFetchProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const { getAccessTokenSilently } = useAuth0()

  const vendorsAxios = axios.create({
    baseURL: import.meta.env.VITE_PROCUREMENT_API_URL
  })

  vendorsAxios.interceptors.request.use(
    async (config) => {
      const token = await getAccessTokenSilently()
      config.headers.Authorization = `Bearer ${token}`
      return config
    },
    (error) => {
      return Promise.reject(error)
    }
  )

  const value = React.useMemo(
    () => ({
      vendorsAxios
    }),
    [vendorsAxios]
  )

  return <Provider value={value}>{children}</Provider>
}

export { VendorsFetchContext, VendorsFetchProvider }
